module.exports = __webpack_public_path__ + "assets/img/zp1.5dfeebfa.jpg";